import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COMMERCIAL_PRICING } from '@connexio/shared/constants';
import { Button, type ButtonProps } from '@/components/ui/button';
import { marketingContactHref } from '../contactHref';

interface PrimaryCtaProps {
  signupEnabled: boolean;
  /** `short` is for the sticky header, where a full sentence does not fit a phone. */
  label?: 'full' | 'short';
  size?: ButtonProps['size'];
  className?: string;
}

/**
 * The page's one primary action, repeated in the header, hero, benefits, pricing and
 * closing band. Free trial when self-service sign-up is on; otherwise the contact
 * fallback, at the same visual weight so the page keeps one obvious next step.
 */
export function PrimaryCta({ signupEnabled, label = 'full', size = 'xl', className }: PrimaryCtaProps) {
  const { t } = useTranslation('marketing');

  if (signupEnabled) {
    return (
      <Button asChild variant="default" size={size} className={className}>
        <Link to="/register">{label === 'short'
            ? t('cta.trialShort')
            : t('cta.trial', { days: COMMERCIAL_PRICING.trialDays })}</Link>
      </Button>
    );
  }

  return (
    <Button asChild variant="default" size={size} className={className}>
      <a href={marketingContactHref()}>{t('cta.contact')}</a>
    </Button>
  );
}
